import React from 'react';

const Layer3 = () => {
  return (
    <svg
      preserveAspectRatio='xMinYMin meet' // You can adjust this as needed
      width='510'
      height='417'
      viewBox='0 0 510 417'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className=' absolute left-[-1px] bottom-[-7px] z-30'
      style={{ height: '417px', width: '510px' }}
    >
      <path
        d='M509.5 371.594C509.5 396.17 489.577 416.094 465 416.094L45 416.094C20.4233 416.094 0.500002 396.17 0.500004 371.594L0.500003 35.7827C13.7238 31.1209 24.5653 31.143 37.7732 31.1701C40.9797 31.1766 44.3257 31.1835 47.8791 31.1237C66.1778 30.8156 89.8059 28.7251 127.856 15.6387C190.703 -5.97586 233.22 11.2306 270.155 26.1778C271.58 26.7544 272.996 27.3276 274.405 27.8951C285.939 32.5406 298.836 31.5939 309.922 26.0174C350.973 5.36748 368.16 -1.07994 391.424 2.02855C403.091 3.58745 416.296 7.55227 434.814 13.3906C436.849 14.0325 438.949 14.6969 441.117 15.383C458.586 20.9106 480.517 27.8503 509.5 35.8109L509.5 371.594Z'
        fill='#083E60'
        fill-opacity='0.7'
        stroke='white'
      />
    </svg>
  );
};

export default Layer3;
